const RESULTS_LINKS = [
  {
    key: 'medicalInsurance',
    render: <a href="../compensation-and-benefits/health-plans/medical/index.html">Medical Insurance</a>
  },
  {
    key: 'dentalInsurance',
    render: <a href="../compensation-and-benefits/health-plans/dental/index.html">Dental Insurance</a>
  },
  {
    key: 'visionInsurance',
    render: <a href="../compensation-and-benefits/health-plans/vision/index.html">Vision Insurance</a>
  },
  {
    key: 'socialSecurity',
    render: 'Social Security'
  },
  {
    key: 'ucPaidLifeInsurance',
    render: <>UC Paid <a href="../compensation-and-benefits/disability-life-accident/life-insurance/index.html">Life Insurance</a></>
  },
  {
    key: 'ucPaidDisablityInsurance',
    render: <>UC Paid <a href="../compensation-and-benefits/disability-life-accident/disability/index.html">Disability Insurance</a></>
  },
  {
    key: 'primaryRetirementBenefit',
    render: <a href="../compensation-and-benefits/retirement-benefits/index.html">Primary Retirement Benefit</a>
  },
];

export default RESULTS_LINKS;
